import {
  Box,
  Text,
  Flex,
  List,
  ListItem,
  Button,
  Input,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { SearchIcon, DeleteIcon, AddIcon } from "@chakra-ui/icons"; // Added AddIcon for consistency
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Exam_Category = () => {
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // Assuming you'll add a modal or navigation for adding a new category later
  // const { isOpen, onOpen, onClose } = useDisclosure();

  const fetchCategory = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/admin/exam/exam_category.php`);
      // Ensure res.data.data is an array before setting state
      setCategories(Array.isArray(res.data.data) ? res.data.data : []);
      console.log("category list...", res.data);
    } catch (error) {
      console.log("error occurred in fetch category", error);
      // Optional: Add a toast notification for error
    }
  };

  const handleDelete = async (id) => {
    // Confirmation prompt (highly recommended for delete actions)
    if (!window.confirm("Are you sure you want to delete this category?")) {
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/exam/delete_examcatogory.php`,
        {
          cat_id: id,
        }
      );

      console.log("Deleted category ID:", id);
      console.log("Delete response:", response.data);

      if (response.data.success) {
        // Remove deleted category from state optimistically
        setCategories((prev) => prev.filter((cat) => cat.id !== id));
        // Optional: Show success toast
      } else {
        console.error(
          "Delete failed:",
          response.data.message || "Unknown error"
        );
        // Optional: Show error toast
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      // Optional: Show error toast
    }
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  // filter categories by search term
  const filteredCategories = categories.filter((cat) =>
    cat.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box
      // borderRadius="md"
      mx="auto"
      bg="gray.50" // Light background for the page area
      minHeight="100vh"
      p={{ base: 4, md: 6, lg: 8 }} // Responsive padding for the entire page
    >
      {/* Centered Content Container - The "Card" for the list */}
      <Box
        mx="auto"
        // maxW={{ lg: "1000px" }} // Max width for content on large screens (Consistent with previous example)
        bg="white"
        // borderRadius="lg" // Larger border radius for modern look
        // shadow="lg"
      >
        {/* Top Section → Heading + Breadcrumbs | Search Bar + Add Button */}
        <Flex
          justify="space-between"
          align="center"
          direction={{ base: "column", md: "row" }} // Stack on mobile
          gap={{ base: 4, md: 0 }} // Gap when stacked
          px={{ base: 4, md: 8, lg: 10 }}
          py={{ base: 5, md: 6 }}
          // borderBottom="1px solid"
          borderColor="gray.200"
          bg="gray.50"
          // borderTopRadius="lg"
        >
          {/* Left Block: Heading and Breadcrumbs */}
          <Box mb={{ base: 3, md: 0 }}>
            <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" mb={1}>
              Exam Category
            </Text>
            {/* Breadcrumb styled with Chakra Text components for consistency */}
            <Text fontSize={{ base: "sm", md: "md" }} color="gray.600">
              <Link
                to="/admin"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span>Dashboard</span>
              </Link>
              <Text as="span" mx={1}>
                /
              </Text>
              <span>Exam</span>
              <Text as="span" mx={1}>
                /
              </Text>
              <Text as="span" fontWeight="semibold">
                Exam Category
              </Text>
            </Text>
          </Box>

          {/* Right Block: Add Button and Search Bar */}
          <Flex
            direction={{ base: "column", sm: "row" }}
            gap={3}
            w={{ base: "100%", md: "auto" }}
            align="center"
          >
            {/* Example Add Button (If you plan to add one) */}
            {/* <Button
              leftIcon={<AddIcon />}
              colorScheme="teal"
              // onClick={onOpen}
              size={{ base: "md", md: "md" }}
              w={{ base: "100%", sm: "auto" }}
            >
              Add Category
            </Button> */}

            {/* Search Bar */}
            <InputGroup w={{ base: "100%", sm: "280px" }}>
              <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
              </InputLeftElement>
              <Input
                type="text"
                placeholder="Search category..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                bg="white"
                borderColor="gray.300"
                _focus={{ borderColor: "blue.400", boxShadow: "sm" }}
              />
            </InputGroup>
          </Flex>
        </Flex>

        {/* Category List Container */}
        <Box
          p={{ base: 4, md: 8, lg: 10 }} // Responsive padding for the list area
          bg="white"
          borderRadius="lg"
          shadow="lg"
          
        >
          {filteredCategories.length === 0 ? (
            <Text fontSize="md" color="gray.500" textAlign="center" py={10}>
              No categories found.
            </Text>
          ) : (
            <List spacing={4}>
              {" "}
              {/* Increased spacing to 4 for better visual separation */}
              {filteredCategories.map((cat) => (
                <ListItem
                  key={cat.id}
                  p={4}
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="lg" // Consistent larger border radius
                  bg="white"
                  shadow="sm"
                  _hover={{ shadow: "md", transform: "translateY(-2px)" }}
                  transition="all 0.2s ease-in-out"
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    direction={{ base: "column", sm: "row" }} // Stack button on mobile
                  >
                    <Text
                      fontWeight="medium"
                      color="gray.700"
                      mb={{ base: 2, sm: 0 }} // Margin below text on mobile
                      textAlign={{ base: "center", sm: "left" }}
                    >
                      {cat.category}
                    </Text>
                    <Button
                      size="sm"
                      colorScheme="red"
                      variant="outline"
                      leftIcon={<DeleteIcon />}
                      onClick={() => handleDelete(cat.id)}
                      w={{ base: "100%", sm: "auto" }} // Full width button on small screens
                    >
                      Delete
                    </Button>
                  </Flex>
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Exam_Category;
